//vuex
import {mapState, mapGetters, mapMutations} from 'vuex'
//axios
import axios from 'axios'
import apiConfig from 'common/js/api_config'

// 定义一个混入对象
export default {
  data() {
    return {
      serviceDetailStatus: true,
      serviceDetailData: {},
    }
  },
  created() {
  },
  computed: {},
  methods: {
    // 进服务详情
    toServiceDetail(itemData) {
      // this.$modal.toggle("serviceHandle", itemData);
      //this.$emit("toServiceDetail", itemData)
      let iframeTypeList = [0, 5, 4]
      if (itemData.type !== 1 && itemData.appOpenType !== 'frame' && iframeTypeList.indexOf(itemData.type) === -1) {
        window.open(itemData.pc_url)
        return
      } else if (iframeTypeList.indexOf(itemData.type) > -1 && itemData.appOpenType === 'frame') {
        this.$modal.show("extraPage", {url: itemData.pc_url, title: itemData.name});
        return
      } else if (iframeTypeList.indexOf(itemData.type) > -1 && itemData.appOpenType !== 'frame') {
        window.open(itemData.pc_url)
        return
      }
      history.pushState(null, null, document.URL);
      this.serviceDetailStatus = false
      this.serviceDetailData = itemData
    },
    closeServiceDetail() {
      this.serviceDetailStatus = true
    },
    backChange() {
      if (this.serviceDetailStatus) {
        this.$router.go(-1)
      } else {
        this.serviceDetailStatus = true
      }
    },
  },
  mounted() {
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.backChange, false)
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.backChange, false)
  },
}



// WEBPACK FOOTER //
// ./src/pages/mixin/serviceDetail.js